import * as types from '../types'

export default function (payload) {
  return {
    type: types.SET_EXPANDED_JOB_ERROR_INFO,
    payload,
  }
}
